import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "@/lib/utils";

const Avatar = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      className
    )}
    {...props}
  />
));
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn("aspect-square h-full w-full", className)}
    {...props}
  />
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      className
    )}
    {...props}
  />
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

const AvatarInitials = ({ name, email, className, ...props }) => {
  const getInitials = (name) => {
    if (!name) return "??";
    const names = name.split(" ");
    return names
      .map((n) => n.charAt(0))
      .join("")
      .substring(0, 2)
      .toUpperCase();
  };

  const getAvatarColor = (email) => {
    if (!email) return "#6B7280"; // Default gray color

    const colors = [
      // "#EF4444", // red
      // "#F97316", // orange
      // "#F59E0B", // amber
      // "#EAB308", // yellow
      // "#84CC16", // lime
      // "#22C55E", // green
      // "#10B981", // emerald
      // "#06B6D4", // cyan
      "#3B82F6", // blue
      // "#6366F1", // indigo
      // "#8B5CF6", // violet
      // "#A855F7", // purple
      // "#EC4899", // pink
      // "#F43F5E", // rose
      // "#6B7280",
    ];

    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }

    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <span
      className={cn(
        "flex h-full w-full items-center justify-center rounded-full text-xl font-medium text-white",
        className
      )}
      style={{ backgroundColor: getAvatarColor(email) }}
      {...props}
    >
      {getInitials(name)}
    </span>
  );
};

export { Avatar, AvatarImage, AvatarFallback, AvatarInitials };
